export enum BodyBoxState {
    Collapsed =1,
    Expanded =2
}
